
(function ($) {

    // ==============================================================
    // Is on screen
    // ==============================================================

    function is_on_screen_item_init() {

        var is_on_screen_item = $('.is_on_screen_item');

        if (is_on_screen_item.length > 0) {
            check_is_on_screen_item();
        }

        $(document).on('scroll load resize', function (event) {

            if (is_on_screen_item.length > 0) {
                check_is_on_screen_item();
            }
        });

        function check_is_on_screen_item() {

            is_on_screen_item.each(function (i) {

                var _ = $(this);

                if (_.isOnScreen(0.4, 0.4)) {

                    _.addClass('is_on_screen');
                }

            });
        }
    }

    $(window).on('load resize', function () {
        is_on_screen_item_init();
    });

    // $(window).on('load', function () {
    //     //************************************
    //     //  covi-19 banner
    //     //************************************
    //     if ($.cookie("covi-19")) {
    //
    //     } else {
    //         $.cookie("covi-19", false, {expires: 360, path: '/'});
    //     }
    //     if ($.cookie("covi-19") === 'false') {
    //         $('#covi_modal').modal('show');
    //         $.cookie("covi-19", true, {expires: 360, path: '/'});
    //     }
    // });


    //************************************
    // Parallax content
    //************************************

    $(document).ready(function () {
        $('.parallaxtop').parallaxContent({
            shift: -40,
            duration: .4
        });

    });

    //************************************
    // anchor top banner home page
    //************************************

    $(document).on('click', '.top-banner .animation-bottom', function (event) {
        event.preventDefault();

        // var $header_height = $('header').outerHeight();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 60
        }, 1000);
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/entry.js